export default __webpack_public_path__ + "static/media/index_2.e304745f.png";